import {blockPage} from "../../../utils/blockPage";
import HiddenNav from "../../classes/HiddenNav";

export const initHeader = () => {
	const header = document.querySelector( `body > header` );
	
	if ( header )
	{
		const siteSubmenu = document.querySelector(`div.site-submenu nav`);
		const navContainer = header.querySelector( `nav > ul` );
		const hiddenNavInstance = new HiddenNav( navContainer );
		const headerMenuInput = document.querySelector( 'input#header_menu' );
		let currentScroll = 0, rememberScrollTop, widthWithScroll, scrollWidth;

		hiddenNavInstance.init( window.innerWidth >= 956 );

		window.addEventListener( `resize`, () => {
			if ( window.innerWidth >= 956 && !hiddenNavInstance.isHiding() )
			{
				hiddenNavInstance.startHiding();
			}
			
			if ( window.innerWidth < 956 && hiddenNavInstance.isHiding() )
			{
				hiddenNavInstance.stopHiding();
			}
		} );

		headerMenuInput.addEventListener( 'change', ( evt ) => {
			if ( window.innerWidth < 956 && evt.target.checked )
			{
				rememberScrollTop = window.scrollY;
				widthWithScroll = document.documentElement.offsetWidth;
				document.documentElement.style.overflow = 'hidden';
				scrollWidth = document.documentElement.offsetWidth - widthWithScroll;
				document.documentElement.style.paddingRight = scrollWidth + 'px';
			}
			else
			{
				document.documentElement.style.overflow = '';
				document.documentElement.style.paddingRight = '';
			}
		} );

		window.addEventListener( `scroll`, () => {
			const submenu = document.querySelector( 'div.site-submenu' );

			if ( submenu )
			{
				if ( submenu.getBoundingClientRect().top <= 0 )
				{
					header.classList.add( `fixed` );
				}
				
				if ( currentScroll < window.pageYOffset )
				{
					header.classList.remove( 'show' );
				}
				else
				{
					header.classList.add( 'show' );
				}

				currentScroll = window.pageYOffset;
			}
			else
			{
				if ( window.pageYOffset >= 0 )
				{
					header.classList.add( `fixed`, 'show' );
				}
			}
			
			// if ( document.body.classList.contains( 'with-submenu' ) )
			// {
			// 	if ( currentScroll < window.pageYOffset )
			// 	{
			// 		header.classList.add( 'scroll-down' );
			// 	}
			// 	else
			// 	{
			// 		header.classList.remove( 'scroll-down' );
			// 	}
			// }

			// currentScroll = window.pageYOffset;
			
			// if ( window.pageYOffset >= 0 )
			// {
			// 	header.classList.add( `fixed`, 'show' );
			// }

			// if ( window.pageYOffset >= window.innerHeight )
			// {
			// 	header.classList.add( `show` );
			// }

			if ( window.pageYOffset <= 0 )
			{
				header.classList.remove( `fixed`, 'show' );
			}

			if ( siteSubmenu )
			{
				siteSubmenu.classList.contains(`fixed`) || !header.classList.contains(`fixed`) ? header.classList.add(`header-no-border`) : header.classList.remove(`header-no-border`);
			}
		} );
	}
};
